<template>
    <div class="news_detail">
        <vheader :type="headerType" :current="currentIndex"></vheader>
        <topbanner :img="bannerImg">
            <h1 class="cl_ff tac">新闻资讯</h1>
        </topbanner>

        <div class="newDetail_cnt">
            <div class="w">
                <h2 class="f_20 b tac tl">{{info.title}}</h2>
                <p class="cl_99 tac time">{{info.publishedDate}}</p>
                <div class="text" v-html="info.content"></div>
            </div>
        </div>
        <loading v-show="loadingFlag"></loading>
        <vfooter></vfooter>
    </div>
</template>

<script>
    import Loading from '@/components/loading/Loading'
    import vfooter from '@/components/footer/Footer'
    import topbanner from '@/components/topBanner/Topbanner'
    import { getNewsDetail, getToken } from '@/request/api'
    import vheader from '@/components/header/Header'
    export default {
        name: 'NewsDetail',
        metaInfo () {
            return {
                title: '互联网企业加快布局“新零售 ',
                meta: [
                    {
                        name: this.info.title,
                        content: '新闻资讯、行业资讯、新零售'
                    },
                    {
                        name: 'description',
                        content: '新零售趋势愈演愈烈，新概念的词汇是与日俱增，我们如何去理解新零售'
                }]
            }
        },
        data () {
            return {
                bannerImg: require('@/assets/images/news_top.jpg'),
                headerType: '2',
                currentIndex: 1,
                id: this.$route.params.id,
                info: {},
                loadingFlag: true
            }
        },
        created() {
            this._getdetail()
        },
        mounted() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
        methods: {
            _getdetail() {
                let that = this
                getToken().then(r => {
                    let params = {
                        id: this.id
                    }
                    getNewsDetail(params, r.data).then(res => {
                        if (res.success) {
                            that.info = res.data
                        }
                        that.loadingFlag = false
                    })
                })
            }
        },
        components: {
            topbanner,
            vheader,
            vfooter,
            Loading
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/less" lang="less">
    .news_detail{
        .topbaner{
            h1{
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 40%;
                z-index: 9;
                font-size: 50px;
            }
        }
    }
    .newDetail_cnt{
        padding-top: 58px;
        padding-bottom: 90px;
        .tl{
            margin-bottom: 18px;
        }
        .time{
            margin-bottom: 30px;
        }
        .text{
            padding-top: 44px;
            border-top: 1px dashed #dcdcdc;
            line-height: 23px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/news/NewsDetail.vue